var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import Swipe from 'react-easy-swipe';
import { overlayStyle, overlayActiveStyle, menuOuterStyle, menuOuterActiveStyle, menuShadowStyle, menuShadowActiveStyle, menuInnerStyle, getSkew, } from './CheeseBurgerStyles';
var IDLE = 'idle';
var VERTICAL = 'vertical';
var HORIZONTAL = 'horizontal';
var CheeseburgerMenu = /** @class */ (function (_super) {
    __extends(CheeseburgerMenu, _super);
    function CheeseburgerMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            swiping: false,
            direction: IDLE,
            swipePosition: { x: 0, y: 0 },
            menuExtraStyle: {},
        };
        _this.onSwipeStart = _this.onSwipeStart.bind(_this);
        _this.onSwipeMove = _this.onSwipeMove.bind(_this);
        _this.onSwipeEnd = _this.onSwipeEnd.bind(_this);
        return _this;
    }
    CheeseburgerMenu.prototype.onSwipeStart = function (event) {
        if (this.props.isOpen) {
            this.setState({
                swiping: true,
            });
        }
    };
    CheeseburgerMenu.prototype.onSwipeMove = function (position, event) {
        if (this.state.swiping) {
            var options = this.getOptions();
            var direction = this.state.direction;
            if (direction === IDLE) {
                var swipeThreshold = options.width / 15;
                var pastThreshold = ((Math.abs(position.x) > swipeThreshold) ||
                    (Math.abs(position.y) > swipeThreshold));
                if (pastThreshold) {
                    if (((!this.props.right && position.x < 0) ||
                        (this.props.right && position.x > 0)) &&
                        Math.abs(position.x) > Math.abs(position.y)) {
                        direction = HORIZONTAL;
                    }
                    else {
                        direction = VERTICAL;
                    }
                }
            }
            if (direction === HORIZONTAL) {
                var swipeClosing = ((!this.props.right && position.x < 0) ||
                    (this.props.right && position.x > 0));
                var translateX = (swipeClosing ? position.x : 0);
                this.setState({
                    direction: direction,
                    swipePosition: position,
                    menuExtraStyle: {
                        transform: getSkew(options) + "translate3d(".concat(translateX, "px, 0px, 0px)"),
                        transition: 'transform 0s',
                    },
                });
                event.preventDefault();
            }
            if (direction === VERTICAL) {
                this.setState({
                    direction: direction,
                    swipePosition: { x: 0, y: 0 },
                    menuExtraStyle: {},
                });
            }
        }
    };
    CheeseburgerMenu.prototype.onSwipeEnd = function (event) {
        var swipeCloseThreshold = this.getOptions().width / 3;
        if ((!this.props.right && this.state.swipePosition.x < -swipeCloseThreshold) ||
            (this.props.right && this.state.swipePosition.x > swipeCloseThreshold)) {
            this.props.closeCallback();
        }
        this.setState({
            swiping: false,
            direction: IDLE,
            swipePosition: { x: 0, y: 0 },
            menuExtraStyle: {},
        });
    };
    CheeseburgerMenu.prototype.getOptions = function () {
        return {
            isLeft: !this.props.right,
            transitionTime: this.props.transitionTime || 0.3,
            topOffset: this.props.topOffset || 0,
            bottomOffset: this.props.bottomOffset || 0,
            width: this.props.width || 300,
            backgroundColor: this.props.backgroundColor || 'white',
            showShadow: !this.props.noShadow,
            skewY: this.props.skewY,
        };
    };
    CheeseburgerMenu.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, closeCallback = _a.closeCallback, className = _a.className, overlayClassName = _a.overlayClassName, outerClassName = _a.outerClassName, innerClassName = _a.innerClassName, shadowClassName = _a.shadowClassName, children = _a.children;
        var options = this.getOptions();
        var baseMenuOuterStyle = (isOpen ? menuOuterActiveStyle(options) : menuOuterStyle(options));
        var currentMenuOuterStyle = __assign(__assign({}, baseMenuOuterStyle), this.state.menuExtraStyle);
        return (React.createElement("div", null,
            React.createElement("div", { 
                /*className={classnames('cheeseburger-menu-overlay', overlayClassName)}*/
                style: isOpen ? overlayActiveStyle(options) : overlayStyle(options), onClick: closeCallback }),
            React.createElement(Swipe, { onSwipeStart: this.onSwipeStart, onSwipeMove: this.onSwipeMove, onSwipeEnd: this.onSwipeEnd },
                React.createElement("div", { 
                    /*className={classnames('cheeseburger-menu-outer', outerClassName)}*/
                    style: currentMenuOuterStyle },
                    React.createElement("div", { 
                        /*className={classnames('cheeseburger-menu-inner', innerClassName)}*/
                        style: menuInnerStyle(options) }, children),
                    React.createElement("div", { 
                        /*className={classnames('cheeseburger-menu-shadow', shadowClassName)}*/
                        style: isOpen ? menuShadowActiveStyle(options) : menuShadowStyle(options) })))));
    };
    return CheeseburgerMenu;
}(Component));
export default CheeseburgerMenu;



//////////////////
// WEBPACK FOOTER
// ./src/components/NavBarMobile/CheeseBurgerMenu.tsx
// module id = 1049
// module chunks = 0